import {DateParser} from './date-parser';
import {DateStruct} from './date-struct';
import {isDefined, safeSplit} from "../../libs/utils/epic.utils";

export abstract class AbstractDateParser implements DateParser {

  public abstract formatLocalDate(date: DateStruct): string;

  public abstract formatLocalDayMonth(date: DateStruct): string;

  public abstract parseLocalDate(value: Date | string | null | undefined): DateStruct;

  public fromDate(value: Date | undefined): string | undefined {
    if (isDefined(value)) {
      return this.formatLocalDate(DateStruct.fromDate(new Date(value)));
    }
    return value;
  }

  public fromLocalDate(value: string | undefined): string | undefined {
    if (isDefined(value)) {
      const parts: string[] = safeSplit(value, '-');
      if (parts.length === 3) {
        const date = new DateStruct({
          day: parseInt(parts[2], 10),
          month: parseInt(parts[1], 10),
          year: parseInt(parts[0], 10)
        });
        return this.formatLocalDate(date);
      }
    }
    return undefined;
  }
}
